import { useMutation } from '@tanstack/react-query';

import { PostRegisterDevicePayload, PostRegisterDeviceResponse } from '@/api/device/types';
import { axios } from '@/common/axios';
import { MutationConfig, queryClient } from '@/common/react-query';
import { useErrorContext } from '@/context/ErrorContext';

export const postRegisterDevice = (payload: PostRegisterDevicePayload) => {
    return axios.post<PostRegisterDeviceResponse, PostRegisterDeviceResponse>('/device/register', payload);
};

type UsePostRegisterDeviceOptions = {
    config?: MutationConfig<typeof postRegisterDevice>;
    data?: PostRegisterDevicePayload;
};

export const usePostRegisterDevice = ({ config }: UsePostRegisterDeviceOptions = {}) => {
    const { createErrorHandler } = useErrorContext();
    return useMutation({
        ...config,
        mutationFn: postRegisterDevice,
        onSuccess: () => {
            // sometimes a /device-id-list request immediately following a new registration doesn't include the new device, so wait a second before invalidating.
            setTimeout(() => {
                queryClient.invalidateQueries({ queryKey: ['device-id-list'] });
                /*
                If subscription was in past_due state before device registration,
                it may have changed to active after successful payment.
                */
                queryClient.invalidateQueries({ queryKey: ['stripe-invoices-list'] });
                queryClient.invalidateQueries({ queryKey: ['stripe-updated-quantity-upcoming-invoice'] });
                queryClient.invalidateQueries({ queryKey: ['stripe-subscription-info'] });
            }, 1000);
        },
        onError: createErrorHandler('register device'),
    });
};
